import { node_observable_component } from 'common/util/ComponentDecorator';

@node_observable_component
export default class courierDpBalloon {
	static classname = 'courier-dp-balloon';

	constructor($balloon) {
		this.$balloon = $balloon;

		this.decorateWrapper();
	}

	decorateWrapper() {
		this.$balloon.closest('ymaps[id^="id_"]').addClass('courier-dp-balloon__identified-wrapper');
		this.$balloon.closest('ymaps[class*="balloon__content"]').addClass('courier-dp-balloon__content-wrapper');

		const $wrapper = this.$balloon.closest('ymaps[class*="balloon_layout"]');
		$wrapper.addClass('courier-dp-balloon__wrapper');

		const $close_button = $wrapper.find('ymaps[class*="balloon__close-button"]');
		$close_button.addClass('courier-dp-balloon__close-button');
		$close_button.parent().addClass('courier-dp-balloon__close-wrapper');

		this.$balloon.closest('ymaps[class*="balloon-panel"]').addClass('courier-dp-balloon__panel-wrapper');

		const $map = this.$balloon.closest('.courier-dp__map');
	}
}
